import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import {useTheme} from '@mui/material/styles';
import {BiInfoCircle} from 'react-icons/bi';

import Alert from '@jobseeker/lotus/components/Alert';
import {VersionVariants} from '@jobseeker/lotus/enums';
import {deferTask, openUrl} from '@jobseeker/common-core/utils/common';

type AtsApplyBannerProps = {
  applyUrl: string;
};
const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

// Shown after applying to a job that redirects the jobseeker to the
// recruiter's own ATS/portal (IIMHIRJS-3874) — lets them resume the
// application here if they didn't finish it on that redirect.
const AtsApplyBanner = ({applyUrl}: AtsApplyBannerProps) => {
  const theme = useTheme();
  const accentColor = theme.palette.primary.main;

  return (
    <Alert
      variant={VersionVariants.VERSION_TWO}
      show={true}
      background="#fff"
      icon={
        <Typography color={accentColor} lineHeight={0} fontSize={{xxs: 20}}>
          <BiInfoCircle />
        </Typography>
      }
      sx={{
        mt: isAppIimjobs ? 0 : {xxs: -1, md: 0},
        borderTop: '1px solid #E7EBF0',
        borderLeft: `4px solid ${accentColor}`,
        borderRadius: '0px',
        borderBottomLeftRadius: '10px !important',
        borderBottomRightRadius: '10px',
      }}
    >
      <Typography fontSize={15} color="text.primary" lineHeight="20px">
        <Box component="span" fontWeight={700}>
          Note:
        </Box>{' '}
        For your candidature to be considered, you must apply on the
        company&apos;s redirected page for this job. If you missed it,{' '}
        <Link
          href={applyUrl}
          onClick={e => {
            e.preventDefault();
            deferTask(() => openUrl(applyUrl, '_blank'));
          }}
          sx={{
            fontWeight: 600,
            cursor: 'pointer',
            color: accentColor,
            whiteSpace: {xxs: 'nowrap', md: 'normal'},
          }}
        >
          complete your application here →
        </Link>
      </Typography>
    </Alert>
  );
};

export default AtsApplyBanner;
